import VerificationStatus from "../../models/companyVerification/VerificationStatus";

function isVerificationStatus(
  potentialVerification: string,
): potentialVerification is VerificationStatus {
  return Object.values(VerificationStatus).some(
    (val) => potentialVerification === val,
  );
}

export default function guaranteedVerificationStatus(
  potentialVerification: string,
) {
  if (isVerificationStatus(potentialVerification)) {
    return potentialVerification;
  }
  return VerificationStatus.Idle;
}
